import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {Toolbar} from "@mui/material";
import {makeStyles} from "tss-react/mui";
import {ALERT, sidebarWidth, sidebarClass} from "../resources/environment";
import {useSidebar} from "./sidebar/Context/SidebarProvider";
import {useFeatureFlags} from "../context/FeatureFlagProvider";

const useMainStyles = makeStyles()((theme, {newSidebarDesign, showSidebarText}) => ({
  content: {
    paddingLeft: newSidebarDesign ?
      showSidebarText ?
        sidebarWidth.open :
        sidebarWidth.collapsed :
      sidebarWidth.open,
    transition: newSidebarDesign ?
      theme.transitions.create("padding", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }) :
      undefined,
    [`&.${sidebarClass}`]: {
      paddingLeft: sidebarWidth.collapsed,
      [theme.breakpoints.down("sm")]: {
        paddingLeft: theme.spacing(1),
      },
    },
    flexGrow: 1,
    zIndex: theme.zIndex.drawer,
    [theme.breakpoints.down("sm")]: {
      paddingLeft: theme.spacing(1),
    },
    "@media print": {
      paddingLeft: 0,
    },
  },
}));

const Main = ({children}) => {
  const {isSidebarHidden, showSidebarText} = useSidebar();
  const {newSidebarDesign} = useFeatureFlags();
  const {classes} = useMainStyles({newSidebarDesign, showSidebarText});
  const sidebarHiddenClass = !newSidebarDesign && isSidebarHidden ? `${sidebarClass}` : "";

  useEffect(() => {
    ALERT.success("Welcome!");
  }, []);

  return (
    <main className={`${classes.content} ${sidebarHiddenClass}`} id="main">
      <Toolbar />
      {children}
    </main>
  );
};

Main.propTypes = {
  children: PropTypes.object,
};

export default Main;
